export default __webpack_public_path__ + "static/media/rectangle.09090899.svg";